import { cva, type VariantProps } from "class-variance-authority"
import { forwardRef, type ReactNode } from "react"
import { cn } from "~/lib/utils"

const badgeVariants = cva(
    "absolute rounded-full min-h-3 min-w-3 p-1 text-xs font-medium content-[''] leading-none grid place-items-center bg-red-500 text-white z-10",
    {
        variants: {
            variant: {

            },
            placement: {
                "top-start": "top-[4%] left-[2%] -translate-x-2/4 -translate-y-2/4",
                "top-end": "top-[4%] right-[2%] translate-x-2/4 -translate-y-2/4"
            },
            withBorder: {
                true: "border-2 border-white"
            },
            withContent: {
                true: "min-h-6 min-w-6"
            }
        }
    }
)

export interface BadgeProps extends VariantProps<typeof badgeVariants> {
    invisible?: boolean
    withBorder?: boolean
    content?: string | number | ReactNode
    children?: ReactNode
    withContent?: boolean
    className?: string
}

const Badge = forwardRef<HTMLDivElement, BadgeProps>(({ children, withBorder, placement, withContent, className, content, invisible, ...props }, ref) => {
    return (
        <div className="inline-flex relative" ref={ref} {...props}>
            {children}
            {!invisible && <span className={cn(badgeVariants({ withBorder, placement, withContent, className }))}>{content}</span>}
        </div>
    )
})

Badge.displayName = "Badge"

export { Badge, badgeVariants }